"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataSender = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// Unit responsible for pushing data across the wire.
var DataSender =
/*#__PURE__*/
function () {
  function DataSender(context) {
    _classCallCheck(this, DataSender);

    this.context = context;
  }

  _createClass(DataSender, [{
    key: "sendData",
    value: function sendData(trackReq) {
      this.callApiService(trackReq);
    }
  }, {
    key: "callApiService",
    value: function callApiService(req) {
      var method = "POST";
      var uri = "".concat(this.context.goEndpoint, "/v1/a/t");
      var xhr = new XMLHttpRequest();
      xhr.open(method, uri, true);

      if (req != null) {
        fetch(uri, {
          method: "POST",
          mode: "cors",
          // no-cors, cors, *same-origin
          cache: "no-cache",
          // *default, no-cache, reload, force-cache, only-if-cached
          credentials: "include",
          // include, *same-origin, omit
          body: JSON.stringify(req),
          headers: {
            "Content-Type": "application/json"
          }
        });
      } else {
        xhr.send();
      }
    }
  }]);

  return DataSender;
}();

exports.DataSender = DataSender;